import { OPTIMIZELY_VTR_BULLET_EXPERIMENT } from '../data';

import { UpsellBullets, UpsellTable } from '../generic';

/*
  getBulletVariation is used by both the sidebar and modal sidebar.
  When making changes, remember to test the impact on both upsells.
*/
const getBulletVariation = ({
  isFBE,
  learningAssistantEnabled,
  variationKey,
  enabled,
  enabledVariation,
}) => {
  /*
    Update the following two lines according to changes in ../data.
    Make any changes necessary for the distinguishing of different components
    for the modal and sidebar as necessary.
  */
  const { VARIATIONS } = OPTIMIZELY_VTR_BULLET_EXPERIMENT;
  const showTestVariation = enabled && variationKey === VARIATIONS.EXPERIMENT;

  if (showTestVariation) {
    return enabledVariation;
  }

  if (variationKey === 'table') {
    return <UpsellTable {...{ isFBE, learningAssistantEnabled }} />;
  }

  return <UpsellBullets {...{ isFBE, learningAssistantEnabled }} />;
};

export default getBulletVariation;
